<script>
    import Button from "@smui/button/Button.svelte";

    import Textfield from "@smui/textfield";

    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";

    import title from "../../components/title";
    import { getObject, setObject } from "../../session";

    export let location;

    let name = "",
        phone = "";

    function next() {
        const shipper = {
            customer_name: name,
            customer_phone: phone,
        };
        setObject("shipper", shipper);
        navigate("/shipper/address");
    }

    onMount(() => {
        title.set("Alamat Pengiriman");
        const shipper = getObject("shipper");
        if ("customer_name" in shipper) name = shipper["customer_name"];
        if ("customer_phone" in shipper) phone = shipper["customer_phone"];
    });
</script>

<div class="content">
    <div class="text">Masukkan nama dan nomor telepon pengirim</div>
    <Textfield
        bind:value={name}
        variant="outlined"
        label="Nama pengirim"
        input$placeholder="Siapa namanya?" />
    <Textfield
        bind:value={phone}
        variant="outlined"
        label="Nomor telepon"
        input$placeholder="Berapa nomor teleponnya?" />
    <Button on:click={next} variant="unelevated" class="rounded">
        Lanjutkan
    </Button>
</div>
